import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=833543f4&scoped=true&"
import script from "./folder.vue?vue&type=script&lang=js&"
export * from "./folder.vue?vue&type=script&lang=js&"
import style0 from "./folder.vue?vue&type=style&index=0&id=833543f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833543f4",
  null
  
)

export default component.exports